import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../config";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";

import Select from 'react-select';

const TrainingScheduleList = () => {

  const [schedules, setSchedules] = useState([]);

  useEffect(() => {
    fetchSchedules();
  }, []);

  const fetchSchedules = async () => {
    try {

      const res = await axios.get(
        `${API_BASE_URL}/training_schedule_list`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`
          }
        }
      );

      setSchedules(res.data.data);

    } catch (error) {
      toast.error("Failed to load training schedules");
    }
  };

  const [showForm, setShowForm] = useState(false);

const [formData, setFormData] = useState({
  training_date: "",
  training_time: "",
  training_location: "",
  question_count: "",
  training_course: "",
  training_topic: "",
  reminder_option: "",
  description: "",
  training_moderator: [],
training_participate: []
});

// const handleChange = (e) => {
//   setFormData({
//     ...formData,
//     [e.target.name]: e.target.value
//   });
// };


const [errors, setErrors] = useState({});

const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const payload = {
      ...formData,
      training_moderator: formData.training_moderator.map(m => m.value),
      training_participate: formData.training_participate.map(p => p.value),
    };

    let res;

    
      // ✅ ADD
      res = await axios.post(
        `${API_BASE_URL}/add_training_schedule`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`
          }
        }
      );
    

    toast.success(res.data.message, { position: "bottom-right", theme: "colored" });

    setShowForm(false);
    // setIsEdit(false);
    setEditId(null);
    // resetForm();
    fetchSchedules();

  } catch (error) {
    if (error.response && error.response.status === 422) {
      const firstError = Object.values(error.response.data.errors)[0][0];
      toast.dismiss();
      toast.error(firstError, { position: "bottom-right", theme: "colored" });
    } else {
      toast.error("Something went wrong");
    }
  }
};

const [locations, setLocations] = useState([]);

const [courses, setCourses] = useState([]);
const [topics, setTopics] = useState([]);

useEffect(() => {
  fetchSchedules();
  fetchLocations();
  fetchCourses();
  fetchEmployees();
}, []);

const fetchLocations = async () => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/locations`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`
        }
      }
    );

    setLocations(res.data.data);

  } catch (error) {
    toast.error("Failed to load locations");
  }
};



const fetchCourses = async () => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/showcourse`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`
        }
      }
    );

    setCourses(res.data.data);

  } catch (error) {
    toast.error("Failed to load courses");
  }
};


const fetchTopics = async (courseId) => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/showtopic/${courseId}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`
        }
      }
    );

    setTopics(res.data || []);

  } catch (error) {
    setTopics([]);
    toast.error("Failed to load topics");
  }
};



const handleChange = async (e) => {
  const { name, value } = e.target;

  // Update form data
  setFormData(prev => ({
    ...prev,
    [name]: value
  }));

  
  // If course changes
  if (name === "training_course") {
    if (value) {
      await fetchTopics(value);   // Load topics of selected course
    } else {
      setTopics([]);              // If course cleared → remove topics
    }

    // Reset topic field when course changes
    setFormData(prev => ({
      ...prev,
      training_course: value,
      training_topic: ""
    }));
  }
};


const [employees, setEmployees] = useState([]);


const fetchEmployees = async () => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/all_regular_employees`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`
        }
      }
    );

    setEmployees(res.data || []);

  } catch (error) {
    toast.error("Failed to load employees");
  }
};


const employeeOptions = employees.map(emp => ({
  value: emp.user_id,
  label: `${emp.first_name} ${emp.last_name} (${emp.employee_id})`
}));



const handleDelete = async (id) => {

  if (!window.confirm("Are you sure you want to delete this training schedule?")) {
    return;
  }

  try {

    const res = await axios.delete(
      `${API_BASE_URL}/delete_training_schedule/${id}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`
        }
      }
    );

    toast.success(res.data.message, {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
    
          });

    // Refresh list after delete
    fetchSchedules();

  } catch (error) {
    toast.error("Failed to delete training schedule");
  }
};



const [editId, setEditId] = useState(null);
const [showEditModal, setShowEditModal] = useState(false);
const [editData, setEditData] = useState({
  training_date: "",
  training_time: "",
  training_location: "",
  question_count: "",
  training_course: "",
  training_topic: "",
  description: "",
  training_moderator: [],
  training_participate: []
});



const handleEditSubmit = async (e) => {
  e.preventDefault();

  try {
    const payload = {
      ...editData,
      training_moderator: editData.training_moderator?.map(m => m.value) || [],
      training_participate: editData.training_participate?.map(p => p.value) || [],
    };

    const res = await axios.put(
      `${API_BASE_URL}/update_training_schedule/${editId}`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`
        }
      }
    );

    toast.success(res.data.message, {
      position: "bottom-right",
      theme: "colored"
    });

    setShowEditModal(false);
    fetchSchedules();

  } catch (error) {

    // ✅ Laravel Validation Error (422)
    if (error.response && error.response.status === 422) {

      const validationErrors = error.response.data.errors;

      const firstError = Object.values(validationErrors)[0][0];

      toast.dismiss(); // remove old toast
      toast.error(firstError, {
        position: "bottom-right",
        theme: "colored"
      });

    } else {
      toast.error("Update failed");
    }
  }
};


const handleEdit = async (id) => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/training_schedule_detail/${id}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`
        }
      }
    );

    const data = res.data.data;

    // Load topics based on selected course
    await fetchTopics(data.course);

    // Convert comma ids into array
    const moderatorIds = (data.moderator || "").split(",").filter(Boolean);
    const participateIds = (data.participate || "").split(",").filter(Boolean);

    const moderatorSelected = employeeOptions.filter(opt =>
      moderatorIds.includes(String(opt.value))
    );

    const participateSelected = employeeOptions.filter(opt =>
      participateIds.includes(String(opt.value))
    );

    setEditData({
      training_date: data.training_date,
      training_time: data.training_time,
      training_location: data.location_id,
      question_count: data.question_count,
      training_course: data.course,
      training_topic: data.topic,
      description: data.description || "",
      training_moderator: moderatorSelected,
      training_participate: participateSelected
    });

    setEditId(id);
    setShowEditModal(true);

  } catch (error) {
    toast.error("Failed to load details");
  }
};


const [showViewModal, setShowViewModal] = useState(false);
const [viewData, setViewData] = useState(null);

const handleView = async (id) => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/training_schedule_detail/${id}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`
        }
      }
    );

    setViewData(res.data.data);
    setShowViewModal(true);

  } catch (error) {
    toast.error("Failed to load details");
  }
};


  return (
    <>
      <ToastContainer />

      <div className="container-fluid">

        {/* Header */}
        <div className="card-header d-flex justify-content-between">
  <h6 style={{ color: "#e96827" }}>
    List All Training Schedule
  </h6>

  <button
    className="btn btn-primary"
    onClick={() => setShowForm(!showForm)}
  >
    {showForm ? "Close" : "Add Training"}
  </button>
</div>

{showForm && (
  <div className="card mb-4">
    <div className="card-header">
      <h3 className="card-title" style={{ color: "#e96827" }}>
 ADD TRAINING SCHEDULE
</h3>
    </div>

    <div className="card-body">
      <form onSubmit={handleSubmit}>
        <div className="row">

          <div className="col-md-4">
            <div className="form-group">
              <label>Training Date </label>
              <input
                type="date"
                name="training_date"
                className="form-control required-input"
                onChange={handleChange}
                
              />
            </div>
          </div>

          <div className="col-md-4">
            <div className="form-group">
              <label>Training Time </label>
              <input
                type="time"
                name="training_time"
                className="form-control required-input"
                onChange={handleChange}
                
              />
            </div>
          </div>


        </div>

        <div className="row">


          <div className="col-md-4">
            <div className="form-group">
  <label>Location</label>
  <select
    name="training_location"
    className="form-control required-input"
    value={formData.training_location}
    onChange={handleChange}
  >
    <option value="">Select Location</option>

    {locations.map((loc) => (
      <option key={loc.place_id} value={loc.place_id}>
        {loc.place_name}
      </option>
    ))}

  </select>
</div>
          </div>


          <div className="col-md-6">
  <div className="form-group">
    <label>How Many Question Schedule Pre and Post Test</label>
    <select
      className="form-control required-input"
      name="question_count"
      value={formData.question_count}
      onChange={handleChange}
    >
      <option value="">Select Question Count</option>

      {[...Array(10)].map((_, index) => (
        <option key={index + 1} value={index + 1}>
          {index + 1}
        </option>
      ))}

    </select>
  </div>
</div>
          
          </div>

        <div className="row">

          <div className="col-md-4">
            <div className="form-group">
              <label>Course</label>
             <select
  name="training_course"
  className="form-control required-input"
  value={formData.training_course}
  onChange={handleChange}
>
  <option value="">Select Course</option>

  {courses.map((course) => (
    <option key={course.id} value={course.id}>
      {course.course_name}
    </option>
  ))}

</select>
            </div>
          </div>

          <div className="col-md-4">
            <div className="form-group">
              <label>Topic</label>
             <select
  name="training_topic"
  className="form-control required-input"
  value={formData.training_topic}
  onChange={handleChange}
  disabled={!formData.training_course}   // 🔥 Important
>
  <option value="">Select Topic</option>

  {topics.map((topic) => (
    <option key={topic.id} value={topic.id}>
      {topic.topic_name}
    </option>
  ))}
</select>
            </div>
          </div>

        </div>

         <div className="row">

          <div className="col-md-8">
        <div className="form-group">
          <label>Description</label>
          <textarea
            name="description"
            className="form-control"
            rows="4"
            onChange={handleChange}
          />
        </div>
        </div>
        </div>


        <div className="row">

          <div className="col-md-4">
  <div className="form-group">
    <label>Training Moderator</label>
    <Select
     isMulti
      options={employeeOptions}
      value={formData.training_moderator}
      onChange={(selected) =>
        setFormData(prev => ({
          ...prev,
          training_moderator: selected
        }))
      }
      placeholder="Select Moderator"
      className="form-control required-input"
      isClearable
    />
  </div>
</div>


<div className="col-md-4">
  <div className="form-group">
    <label>Training Participants</label>
    <Select
      isMulti
      options={employeeOptions}
      value={formData.training_participate}
      onChange={(selected) =>
        setFormData(prev => ({
          ...prev,
          training_participate: selected || []
        }))
      }
      placeholder="Select Participants"
      className="form-control required-input"
    />
  </div>
</div>

        </div>

        <div className="mt-3">
          <button type="submit" className="btn btn-primary">
 Save
</button>
        </div>

      </form>
    </div>
  </div>
)}


{showEditModal && (
  <div className="modal d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
    <div className="modal-dialog modal-lg">
      <div className="modal-content">

        <div className="modal-header">
          <h5 className="modal-title">Edit Training Schedule</h5>
          <button className="close" onClick={() => setShowEditModal(false)}>
            &times;
          </button>
        </div>

        <form onSubmit={handleEditSubmit}>
          <div className="modal-body">

            <div className="row">
              <div className="col-md-6">
                <label>Training Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={editData.training_date}
                  onChange={(e) =>
                    setEditData({ ...editData, training_date: e.target.value })
                  }
                />
              </div>

              <div className="col-md-6">
                <label>Training Time</label>
                <input
                  type="time"
                  className="form-control"
                  value={editData.training_time}
                  onChange={(e) =>
                    setEditData({ ...editData, training_time: e.target.value })
                  }
                />
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-md-6">
                <label>Location</label>
                <select
                  className="form-control"
                  value={editData.training_location}
                  onChange={(e) =>
                    setEditData({ ...editData, training_location: e.target.value })
                  }
                >
                  <option value="">Select</option>
                  {locations.map(loc => (
                    <option key={loc.place_id} value={loc.place_id}>
                      {loc.place_name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-6">
                <label>Question Count</label>
                <select
                  className="form-control"
                  value={editData.question_count}
                  onChange={(e) =>
                    setEditData({ ...editData, question_count: e.target.value })
                  }
                >
                  <option value="">Select</option>
                  {[...Array(10)].map((_, i) => (
                    <option key={i + 1} value={i + 1}>
                      {i + 1}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="mt-3">
              <label>Description</label>
              <textarea
                className="form-control"
                value={editData.description}
                onChange={(e) =>
                  setEditData({ ...editData, description: e.target.value })
                }
              />
            </div>

            <div className="row mt-3">
              <div className="col-md-6">
                <label>Moderator</label>
                <Select
                  isMulti
                  options={employeeOptions}
                  value={editData.training_moderator}
                  onChange={(selected) =>
                    setEditData({ ...editData, training_moderator: selected })
                  }
                />
              </div>

              <div className="col-md-6">
                <label>Participants</label>
                <Select
                  isMulti
                  options={employeeOptions}
                  value={editData.training_participate}
                  onChange={(selected) =>
                    setEditData({ ...editData, training_participate: selected })
                  }
                />
              </div>
            </div>

          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setShowEditModal(false)}
            >
              Close
            </button>
            <button className="btn btn-primary">
              Update
            </button>
          </div>

        </form>

      </div>
    </div>
  </div>
)}



{showViewModal && viewData && (
  <>
    <div className="modal fade show" style={{ display: "block" }}>
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content">

          <div className="modal-header">
            <h5 className="modal-title">Training Schedule Details</h5>
            <button
              type="button"
              className="close"
              onClick={() => setShowViewModal(false)}
            >
              &times;
            </button>
          </div>

          <div className="modal-body">

            <div className="row">
              <div className="col-md-6">
                <strong>Date:</strong>
                <p>{viewData.training_date}</p>
              </div>

              <div className="col-md-6">
                <strong>Time:</strong>
                <p>{viewData.training_time}</p>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <strong>Location:</strong>
                <p>{viewData.location_name}</p>
              </div>

              <div className="col-md-6">
                <strong>Course:</strong>
                <p>{viewData.course_name}</p>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <strong>Topic:</strong>
                <p>{viewData.topic_name}</p>
              </div>

              <div className="col-md-6">
                <strong>Question Count:</strong>
                <p>{viewData.question_count}</p>
              </div>
            </div>

            <div className="mt-3">
  <strong>Description:</strong>
  <p>{viewData.description || "N/A"}</p>
</div>

{/* MODERATOR */}
<div className="mt-3">
  <strong>Moderator:</strong>
  <p>
    {viewData.moderator
      ? viewData.moderator
          .split(",")
          .map(id =>
            employeeOptions.find(emp => String(emp.value) === id)?.label
          )
          .filter(Boolean)
          .join(", ")
      : "N/A"}
  </p>
</div>

{/* PARTICIPANTS */}
<div className="mt-3">
  <strong>Participants:</strong>
  <p>
    {viewData.participate
      ? viewData.participate
          .split(",")
          .map(id =>
            employeeOptions.find(emp => String(emp.value) === id)?.label
          )
          .filter(Boolean)
          .join(", ")
      : "N/A"}
  </p>
</div>

          </div>

          <div className="modal-footer">
            <button
              className="btn btn-secondary"
              onClick={() => setShowViewModal(false)}
            >
              Close
            </button>
          </div>

        </div>
      </div>
    </div>

    <div className="modal-backdrop fade show"></div>
  </>
)}

        {/* Table Card */}
        <div className="card">
           {/*<div className="card-header">
            <h6 className="card-title" style={{ color: "#e96827" }}>
              List All Training Schedule
            </h6>
          </div>*/}

          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-hover table-striped">
                <thead>
                  <tr>
                    <th>Action</th>
                    <th>Course</th>
                    <th>Topic</th>
                    <th>Location</th>
                    <th>View Training Status</th>
                    <th>Date</th>
                    <th>Time</th>
                    <th>Added Date</th>
                  </tr>
                </thead>

                <tbody>
                  {schedules.length > 0 ? (
                    schedules.map((item, index) => (
                      <tr key={index}>
                        <td>
                         <i
  className="fe fe-edit mr-2 text-info"
  style={{ cursor: "pointer" }}
  onClick={() => handleEdit(item.id)}
/>

                         <i
  className="fe fe-eye text-primary mr-2"
  style={{ cursor: "pointer" }}
  onClick={() => handleView(item.id)}
/>

                          <i
  className="fe fe-trash text-danger"
  style={{ cursor: "pointer" }}
  onClick={() => handleDelete(item.id)}
/>
                        </td>

                        <td>{item.course_name}</td>
                        <td>{item.topic_name}</td>
                        <td>{item.location_name}</td>
                        <td><Link to={`/TrainingViewStatus/${item.id}`}>
                              <button className="btn btn-xs btn-outline-info">
                                 <i className="fe fe-maximize" />
                              </button>
                            </Link></td>
                        <td>
                          {new Date(item.training_date).toLocaleDateString()}
                        </td>
                        <td>{item.training_time}</td>
                        <td>
                          {new Date(item.added_date).toLocaleDateString()}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="text-center">
                        No Training Schedule Found
                      </td>
                    </tr>
                  )}
                </tbody>

              </table>
            </div>
          </div>
        </div>

      </div>
    </>
  );
};

export default TrainingScheduleList;